import { HTMLAttributes, FC, useState, useEffect, useRef } from "react";
import clsx from "classnames";
import i18next from "i18next";
import { Header, Icon, CircularProgress, useCustomNavigate } from "@onmo/ui";
import { useStyles } from "./GoogleDocsTerms.style";
import { useAppSelector } from "../../../hooks";
import { getDocUrl } from "../../../models/theme";

interface IGoogleDocsTermsProps {
  onBack?: () => void;
  type?: "privacy" | "term" | "faq" | null;
  title: string;
}

export const GoogleDocsTerms: FC<
  IGoogleDocsTermsProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { handleBack } = useCustomNavigate();
  const { theme } = useAppSelector((state) => state.theme);
  const { type, title, ...otherProps } = props;
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      const handleLoad = () => setIsLoading(false);
      iframe.addEventListener("load", handleLoad);
      return () => {
        iframe.removeEventListener("load", handleLoad);
      };
    }
  }, []);

  return (
    <div {...otherProps} className={clsx(classes.root, props.className)}>
      <Header
        title={title}
        leftElement={
          <Icon name="icon-bold-arrow-left-3" onClick={() => handleBack()} />
        }
      />
      <div className={classes.content}>
        {isLoading && (
          <div className={classes.loading}>
            <CircularProgress
              size={35}
              enableAnimation
              className={classes.loadingCircle}
            />
          </div>
        )}
        <iframe
          ref={iframeRef}
          title={type || ""}
          className={clsx(classes.iframe, type === "faq" && "isFaq")}
          src={getDocUrl(i18next.language, theme?.legalDocuments, type)}
        />
      </div>
    </div>
  );
};
